export default __webpack_public_path__ + "static/media/tagmsg.958f8dc5.svg";